import React, { useEffect, useState } from "react";
import Select from "react-select";
import { ExamPopUp } from "../IndexPage/ExaminationPreparation/ExamPopUp";
import { useDispatch, useSelector } from "react-redux";
import { LicentiateCertificateAPI } from "../../helper/Redux/Slices/DDLSlice/DDLSlice";

export const LicentiateCertificateDDL = (props) => {
    const { LicentiateCertificateID, setLicentiateCertificateID, M_MainSubjectID, M_UserID, Flag, rowData } = props


    const dispatch = useDispatch()

    useEffect(() => {
        const data = { M_MainSubjectID, M_UserID, Flag }
        dispatch(LicentiateCertificateAPI({ data }))
    }, [])

    const { DDLData } = useSelector(state => state.LicentiateCertificateData)

    useEffect(() => {
        GetDDLData()
    }, [DDLData])

    const GetDDLData = () => {
        // console.log(DeptDDLDataa)
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_MainSubjectID,
                label: item.mainSubject_Name,
            }))

            setLicentiateCertificateID({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_MainSubjectID : 0,
                Label: Flag === 'Update' ? rowData.mainSubject_Name : "Select...",
            })
        }
        else {
            setLicentiateCertificateID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }


    return (
        <>
            <div className="form-group">
                {/* <label className="d-block" htmlFor="NameofLicentiateCertificateID"><b>LicentiateCertificateID </b></label> */}
                <Select
                    isClearable
                    // isRtl={isRtl}
                    // className="ddl_width"
                    isSearchable
                    maxMenuHeight={150}
                    value={{ value: LicentiateCertificateID.ID, label: LicentiateCertificateID.Label }}
                    onChange={(e) => {
                        e ?
                            setLicentiateCertificateID({ ...LicentiateCertificateID, ID: e.value, Label: e.label })
                            :
                            setLicentiateCertificateID({ ...LicentiateCertificateID, ID: 0, Label: "Select..." })

                    }}
                    options={LicentiateCertificateID.DDL}
                />
            </div>
        </>
    )
}